module.exports = __webpack_public_path__ + "img/icon01.3f1fb670.jpg";